import {HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {Upload} from '../interfaces/upload.interface';

/**
 * Progression d'upload
 * https://nils-mehlhorn.de/posts/angular-file-upload-progress
 */
export const initialState: Upload = { state: 'PENDING', progress: 0 };

function isHttpResponse<T>(event: HttpEvent<T>): event is HttpResponse<T> {
  return event.type === HttpEventType.Response;
}

function isHttpProgressEvent(event: HttpEvent<Upload>): event is HttpProgressEvent {
  return (event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.UploadProgress);
}

export const calculateState = (upload: Upload, event: HttpEvent<Upload>): Upload => {
  if (isHttpProgressEvent(event)) {
    return {
      progress: event.total
        ? Math.round((100 * event.loaded) / event.total)
        : upload.progress,
      state: 'IN_PROGRESS',
    };
  }
  if (isHttpResponse<Upload>(event)) {
    const id = event?.body?.id;
    return <Upload> {
      id: id,
      progress: 100,
      state: 'DONE',
    };
  }
  return upload;
};
